import React from 'react'

import { Link } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { Box, Button, Divider, Paper, Typography } from '@material-ui/core'

import { routes } from 'routes'
import { TablePagination } from 'components/Table'
import { Permitted } from 'components/Permissions'
import * as service from 'service'
import UsersTable from './components/UsersTable'
import usePagination from 'hooks/usePagination'
import useFetch from 'hooks/useFetch'

const UsersMain = () => {
  const {
    perPage,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
  } = usePagination(20)

  const { response, isLoading, refresh } = useFetch(
    service.recurrence.users.get,
    { perPage, page },
    [page, perPage],
  )

  return (
    <Paper>
      <Box
        p={2}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h4">Usuários</Typography>
        <Box>
          <Permitted tag="create_user">
            <Button
              color="primary"
              variant="contained"
              component={Link}
              to={routes.settings.users.new}
            >
              Novo
            </Button>
          </Permitted>
        </Box>
      </Box>
      <Divider />

      <PerfectScrollbar>
        <UsersTable
          users={response && response.data.users}
          isLoading={isLoading}
          onEvent={refresh}
        />
      </PerfectScrollbar>

      <Box px={2} display="flex" justifyContent="flex-end">
        {response ? (
          <TablePagination
            count={response.data.meta.totalCount}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
            page={page}
            rowsPerPage={perPage}
          />
        ) : (
          <Box py="11px"> </Box>
        )}
      </Box>
    </Paper>
  )
}

export default UsersMain
